import { Component, Input } from '@angular/core';
import { ResourceAuthorDetails } from '@app/app/shared/models';

@Component({
  selector: 'ptl-content-item-author',
  templateUrl: './content-item-author.component.html',
  styleUrls: ['./content-item-author.component.scss'],
})
export class ContentItemAuthorComponent {
  @Input() authorDetails: ResourceAuthorDetails | null = null;
}
